/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_PAY_TX } from "../graphql/createPayTx.mutation";
import { VApplication } from "../../../application";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { buildCashPayPayload } from "../../shared/cashPayPayloadBuilder";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface CreatePayTxProps {
  amount: number;
  currency?: string;
  notes?: string;
  payOrder?: boolean;
  mode?: string;
}
export interface ICreatePayTxMethods extends IPluginMethodMap {
  createPayTx(args: any): Promise<any>;
}

export class CreatePayTxService implements IAgentPlugin {
  readonly methods: ICreatePayTxMethods;

  constructor() {
    this.methods = {
      createPayTx: this.createPayTx.bind(this),
    };
  }

  async createPayTx(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    if (args?.payOrder?.id === null || args?.payOrder?.id === undefined) {
      throw Error("Pay order cannot be null or empty");
    }
    try {
      if (client) {
        const payloadData = buildCashPayPayload({
          amount: args?.event?.amount,
          currency: args?.event?.currency,
          notes: args?.event?.notes,
          mode: args?.event?.paymentType || args?.event?.mode,
          payOrder: args?.payOrder?.id,
          costumeId:
            args?.costumeId ||
            args?.payOrder?.box?.[0]?.costumeID ||
            args?.payOrder?.costumeID,
          groupId:
            args?.groupId ||
            args?.payOrder?.groupId ||
            args?.event?.groupId,
          isMultiplePurchase:
            args?.isMultiplePurchase || args?.event?.isMultiplePurchase,
          allocations: args?.event?.allocations,
          splitMap: args?.event?.splitMap || args?.splitMap,
          boxes: args?.event?.boxes || args?.boxes,
        });

        const res = await client.mutate({
          mutation: CREATE_PAY_TX,
          variables: {
            data: payloadData,
            email: args?.event?.invoice_email,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
